import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" }));
export default SvgChevronDown;
